const host = process.env.REACT_APP_SERVER_HOST;

export default {
  experience: { get: `${host}/v2/experience/menu` },
  template: { get: `${host}/v2/experience/menu/template` },
  experienceSteps: { get: `${host}/v2/experience/menu/steps` },
  templateConfig: { get: `${host}/v2/experience/menu/template/preview` },
  clickAnalytics: { post: `${host}/v2/experience/menu/click-analytics` }
};
